import React, { Fragment, useContext, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import toaster from "toasted-notes";
import { useHistory } from "react-router-dom";

import "toasted-notes/src/styles.css";
import { CardLoader, PosCardStyled, PosIconWrap } from "../checkoutPos.styles";
import { SemiBoldText } from "../../../../common/common.styles";
import { RightArrow } from "../../../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";
import { PosIcon } from "../../../../common/assets/icons/catalogueIcons";
import { ActionTypes, ChargeItemsContext } from "../../context";
import { checkoutSalesOrder } from "../../../../../../redux/actions/salesOrder.acton";
import PendingModal from "../../common/modals/PendingModal";
import { Portal } from "../../../../../AuthenticatedApp/components/modals/Portal";

const bgColors = ["#48D38A", "#1DCBEF", "#FFC83E", "#F7685B"];

const PosCard = ({ item, index }) => {
    const [isSubmittingIndex, setIsSubmittingIndex] = useState(-1);
    const [showPendingModal, setShowPendingModal] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState({
        orderId: "",
        deviceName: "",
    });

    const { state, contextDispatch } = useContext(ChargeItemsContext);

    const dispatch = useDispatch();
    const history = useHistory();

    const selectedBg = bgColors[index % bgColors.length];

    const handleCheckoutOrder = async () => {
        setIsSubmittingIndex(index);
        const groupCustomerId = Cookies.get("groupCustomerId");

        const payload = {
            id: state.orderId,
            ownerID: groupCustomerId,
            channel: 2,
            selltoken: item.accessCode,
        };
        console.log(payload, "<<<<PAYLOAD");
        try {
            const { status, message, data } = await dispatch(checkoutSalesOrder(payload));
            setIsSubmittingIndex(-1);

            if (status) {
                setFeedbackMessage((prev) => ({
                    ...prev,
                    orderId: data.orderID,
                    deviceName: item.nameOfPos,
                }));
                setShowPendingModal(true);
            } else {
                toaster.notify(message || "Sorry, an error occurred, Kindly try again.", {
                    duration: 5000,
                    position: "bottom",
                });
            }
        } catch (error) {
            setIsSubmittingIndex(-1);
        }
    };

    const handleClosePendingModal = () => {
        contextDispatch({
            type: ActionTypes.RESET_ORDER,
        });
        setShowPendingModal(false);
        history.push("/sales/catalogue");
    };
    return (
        <Fragment>
            <PosCardStyled
                onClick={handleCheckoutOrder}
                loadingStyled={isSubmittingIndex === index}
            >
                <PosIconWrap bgColor={selectedBg} loadingStyled={isSubmittingIndex === index}>
                    <PosIcon />
                </PosIconWrap>
                <div className="sales__checkout-pos-item-bottom">
                    <SemiBoldText>{item.nameOfPos}</SemiBoldText>
                    {isSubmittingIndex === index ? (
                        <CardLoader />
                    ) : (
                        <div>
                            <RightArrow />
                        </div>
                    )}
                </div>
            </PosCardStyled>
            {showPendingModal && (
                <Portal>
                    <PendingModal
                        feedbackMessage={feedbackMessage}
                        closeModal={() => setShowPendingModal(false)}
                        onSuccessButtonClick={handleClosePendingModal}
                    />
                </Portal>
            )}
        </Fragment>
    );
};

export default PosCard;
